import { analytics } from '@/services/Analytics'
import { getGrowthbook } from './utils'

// Wrap analytics.track in a function to avoid accessing it during module initialization
const trackFn: typeof analytics.track = (...args) => analytics.track(...args)

const growthbook = getGrowthbook({}, trackFn)

export { growthbook }
